import * as MutationTypes from './mutationsTypes';

const powerBiParams = (state, payload) => {
  state.powerBiParams = payload;
};

export const mutations = {
  [MutationTypes.POWER_BI_PARAMS]: powerBiParams,
};
